import { node } from 'prop-types';
import React from 'react';
import { isMobile } from 'react-device-detect';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';

import CardDragLayer from './CardDragLayer';

const DEFAULT_TOUCH_START_DELAY_IN_MS = 200;

const MOBILE_OPTIONS = {
  delayTouchStart: DEFAULT_TOUCH_START_DELAY_IN_MS,
  enableTouchEvents: true,
  touchSlop: 0,
};

const DragAndDropProvider = ({ children }) => (
  <DndProvider
    backend={isMobile ? TouchBackend : HTML5Backend}
    options={isMobile ? MOBILE_OPTIONS : {}}
  >
    {isMobile && <CardDragLayer />}
    {children}
  </DndProvider>
);

DragAndDropProvider.propTypes = {
  children: node.isRequired,
};

export default DragAndDropProvider;
